import { render, staticRenderFns } from "./observed_2.vue?vue&type=template&id=09f735a4&scoped=true&"
var script = {}
import style0 from "./observed_2.vue?vue&type=style&index=0&id=09f735a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f735a4",
  null
  
)

export default component.exports